import React from "react";
import ReactECharts from "echarts-for-react";

const NightingaleChart = ({ stats }) => {
  // Handle missing stats data, defaulting to 0 if reviews, bookings, or requests are not provided
  const defaultStats = { bookings: 0, requests: 0, reviews: 0 };
  const data = stats || defaultStats;

  const option = {
    title: {
      text: "Reviews",
      subtext: "Website Analytics",
      left: "center",
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b}: {c} ({d}%)", // Adds percentage display
    },
    legend: {
      orient: "horizontal",
      bottom: 0,
    },
    series: [
      {
        name: "Website Data",
        type: "pie",
        radius: [20, 120],
        center: ["50%", "50%"],
        roseType: "area", // Rose chart to display in radial form
        itemStyle: {
          borderRadius: 8, // Adds rounded corners to chart slices
        },
        data: [
          { value: data.bookings, name: "Bookings", itemStyle: { color: "#5470C6" } },
          { value: data.requests, name: "Contact Requests", itemStyle: { color: "#91CC75" } },
          { value: data.reviews, name: "Reviews", itemStyle: { color: "#FAC858" } }, // Reviews added to data
        ],
      },
    ],
    responsive: true, // Ensures the chart is responsive
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <ReactECharts option={option} style={{ height: 400, width: "100%" }} />
    </div>
  );
};

export default NightingaleChart;

